<template lang="html">
  <div class="card category-grid ">
    <h3>{{ $t("appliance.all_recipes") }}</h3>

    <Dialog
      v-model:visible="showRecipe"
      v-if="selectedRecipe"
      :modal="true"
      :header="$t(selectedRecipe.key)"
    >
      <recipe-popup
        @recipeStarted="recipeStarted()"
        :selectedRecipe="selectedRecipe"
      ></recipe-popup>
    </Dialog>

    <DataView
      class="all_recipes"
      :value="recipes"
      layout="grid"
      :paginator="true"
      :rows="9"
    >
      <template #grid="slotProps">
        <div
          @click="selectRecipe(slotProps)"
          class="col-4 container-recipe m-0 p-3 link-recipe"
        >
          <div
            class="product-grid-item card image-background-list"
            :style="{
              backgroundImage: 'url(' + getCoverImage(slotProps) + ')',
            }"
          ></div>

          <div class="product-grid-item-bottom">
            <h4>{{ $t(slotProps.data.attributes.key) }}</h4>

            <div class="text-right">
              <div
                class="liked-category mr-4"
                v-if="slotProps.data.liked != undefined"
              >
                <i class="pi pi-heart-fill"></i>
                <p>{{ $t("liked") }}</p>
              </div>
              <div class="timing-category">
                <i class="pi pi-clock"></i>
                {{
                  slotProps.data.attributes.cooking_time +
                    slotProps.data.attributes.prep_time +
                    " Min"
                }}
              </div>
            </div>
          </div>
        </div>

        <!--


                <div class="col-12 lg:col-6 xl:col-4 recipe_card">
                  <img class="pointer" :src="getCoverImage(slotProps)" alt="">
                  <p>{{ $t(slotProps.data.attributes.key) }}</p>

                </div>
                -->
      </template>
    </DataView>
  </div>
</template>
<script>
import request from "../service/httpService";
import RecipePopup from "../components/recipe-popup.vue";
import { importTranslations } from "../service/Utils";

export default {
  data() {
    return {
      showRecipe: false,
      selectedRecipe: null,
      recipes: [],
    };
  },
  computed: {},

  methods: {
    getCoverImage(el) {
      let cover = "";
      const regex = new RegExp(/_[0-9]*_[a-zA-Z0-9]*.png/);
      el.data.attributes.media.data.forEach((element) => {
        if (!element.attributes.url.match(regex)) {
          cover = element.attributes.url;
        }
      });
      return cover;
    },
    recipeStarted() {
      // toast
      this.$toast.add({
        severity: "success",
        summary: "",
        detail: this.$t("toast.success"),
        life: 3000,
      });
      this.showRecipe = false;
    },
    selectRecipe(recipe) {
      this.selectedRecipe = recipe.data.attributes;
      this.selectedRecipe.id = recipe.data.id;
      this.showRecipe = true;
    },
  },
  mounted() {
    request("get", "recipe", "", {
      populate:
        "ingredients.*,ingredients.ingredient,ingredients.ingredient.labels,media,labels,ingredients.unit.labels",
      "pagination[pageSize]": 100,
    }).then((response) => {
      this.recipes = response.data;
      importTranslations(this.recipes, this.$i18n);
      //this.importRecipesTranslations();
    });
  },
  components: {
    "recipe-popup": RecipePopup,
  },
};
</script>
<style lang="scss" scoped></style>
